__turbopack_context__.v({
  "aside": "Learn-module__XaUswW__aside",
  "coverBand": "Learn-module__XaUswW__coverBand",
  "hero": "Learn-module__XaUswW__hero",
  "hubIntro": "Learn-module__XaUswW__hubIntro",
  "intro": "Learn-module__XaUswW__intro",
  "layout": "Learn-module__XaUswW__layout",
  "main": "Learn-module__XaUswW__main",
  "moduleGrid": "Learn-module__XaUswW__moduleGrid",
  "page": "Learn-module__XaUswW__page",
  "shareRow": "Learn-module__XaUswW__shareRow",
  "title": "Learn-module__XaUswW__title",
});
